import { isServer } from './';
const availableThumbnails = {
  small1x: '60x60',
  small3x: '200x200',
  logo1x: '275x275',
  logo2x: '550x550',
  medium1x: '325x303',
  mediuml1x: '496x310',
  big1x: '666x416',
  big2x: '1332x832',
  big3x: '1920x1200',
};

const DIMENSIONS = {
  // size:  [1x,  2x, 3x, 4x];
  small: [availableThumbnails.small1x, availableThumbnails.small3x],
  logoBig: [availableThumbnails.logo1x, availableThumbnails.logo2x],
  medium: [
    availableThumbnails.medium1x,
    availableThumbnails.big1x,
    availableThumbnails.big2x,
    availableThumbnails.big3x,
  ],
  medium_l: [availableThumbnails.mediuml1x, availableThumbnails.big2x, availableThumbnails.big3x],
  big: [availableThumbnails.big1x, availableThumbnails.big2x, availableThumbnails.big3x],
};

export function getImageSize(src, size, seo = '') {
  return getImage(src, size, 'scale_crop', seo, '/smart');
}

export function getImagePreview(src, size, seo = '', filter = '/smart') {
  return getImage(src, size, 'scale_crop', seo, filter);
}

export function getImageContain(src, size, seo = '', filter = '') {
  return getImage(src, size, 'preview', seo, filter);
}

export function getDevicePixelRatio(size) {
  try {
    const ratio = !isServer ? Math.round(window?.devicePixelRatio) || 1 : 1;
    if (ratio) {
      if (DIMENSIONS?.[size]) {
        //Predefined size:
        return DIMENSIONS?.[size]?.[ratio - 1]
          ? DIMENSIONS?.[size]?.[ratio - 1] // if defined returned the size for this pixelratio
          : DIMENSIONS?.[size][DIMENSIONS?.[size].length - 1]; // last element
      }
    }
    return size;
  } catch (e) {
    console.log(e);
    return DIMENSIONS[size] ? DIMENSIONS[size][0] : size;
  }
}

function getImage(src, size, mode = 'scale_crop', seo = '', filter = '') {
  if (!size) return src;
  if (src && src.indexOf('ucdn') !== -1) {
    const dimensions = getDevicePixelRatio(size);

    const newValue = `-/quality/better/-/${mode}/${dimensions}${filter}/${seo}`;

    if (src.indexOf('-/preview/200x200/') !== -1) {
      src = src.replace('-/preview/200x200/', newValue);
    } else if (src.indexOf('-/scale_crop/200x200/smart/') !== -1) {
      src = src.replace('-/scale_crop/200x200/smart/', newValue);
    } else if (src.indexOf('-/scale_crop/200x200/') !== -1) {
      src = src.replace('-/scale_crop/200x200/', newValue);
    } else {
      src += newValue;
    }
  }
  return src;
}
